<template>
  <div class="page">
    <div class="page-container">
      <div class="page-title">新增其他项目</div>
      <div class="w1100">
        <div class="panel">
          <div class="panel-body">
            <a-form-model class="form-sm" ref="form" :model="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
              <a-row :gutter="0">
                <a-col span="24">
                  <a-form-model-item :colon="false" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                    <span slot="label">
                      <i class="required-mark">*</i>
                      项目名称
                    </span>
                    <a-input placeholder="项目名称" allowClear v-model="form.name" ref="name" />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row :gutter="0">
                <a-col span="12">
                  <a-form-model-item :colon="false">
                    <span slot="label">
                      <i class="required-mark">*</i>
                      项目类型
                    </span>
                    <a-select placeholder="选择类型" v-model="form.type" style="width: 200px" ref="type">
                      <a-select-option value="突发事件">突发事件</a-select-option>
                      <a-select-option value="重大活动">重大活动</a-select-option>
                    </a-select>
                    <!-- <a-auto-complete v-model="form.type" style="width: 200px" placeholder="选择或输入类型" allow-clear :filter-option="filterOption">
                      <template slot="dataSource">
                        <a-select-option value="突发事件">突发事件</a-select-option>
                        <a-select-option value="重大活动">重大活动</a-select-option>
                      </template>
                    </a-auto-complete> -->
                  </a-form-model-item>
                </a-col>
                <a-col span="12">
                  <a-form-model-item :colon="false" prop="period">
                    <span slot="label">
                      <i class="required-mark">*</i>
                      美丽心灵管理费率
                    </span>
                    <a-input-number ref="ownManageRate" placeholder="不超过10%" class="no-handler text-right" :min="0" :max="10" :formatter="value => `${value}%`" :parser="value => value.replace('%', '')" v-model="form.ownManageRate" />
                  </a-form-model-item>
                </a-col>
                <!-- <a-col span="12">
                  <a-form-model-item :colon="false">
                    <span slot="label">
                      <i class="required-mark">*</i>
                      项目编号
                    </span>
                    <a-input allowClear v-model="form.code" ref="code" />
                  </a-form-model-item>
                </a-col> -->
              </a-row>
              <a-row :gutter="0">
                <a-col span="12">
                  <a-form-model-item :colon="false">
                    <span slot="label">
                      <i class="required-mark">*</i>
                      实施周期
                    </span>
                    <a-range-picker v-model="form.dates" format="YYYY-MM-DD" value-format="YYYY-MM-DD" ref="datePicker" style="width: 200px" />
                  </a-form-model-item>
                </a-col>
                <a-col span="12">
                  <a-form-model-item :colon="false">
                    <span slot="label">受助对象</span>
                    <a-input placeholder="受助对象" allowClear v-model="form.target" ref="target" />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col span="24">
                  <a-form-model-item :colon="false" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" prop="addr">
                    <span slot="label">
                      <i class="required-mark">*</i>
                      实施地点
                    </span>
                    <template v-if="addressList.length > 0">
                      <div class="flex items-center" v-for="(item, index) in addressList" :key="index">
                        <div style="width: calc(100% - 160px)">
                          <a-input-group compact>
                            <a-cascader changeOnSelect style="width: 320px" expand-trigger="hover" :show-search="{ cascaderFilter }" :options="districts" placeholder="选择地区" v-model="item.districts" :ref="`districts-${index}`" />
                            <a-input style="width: calc(100% - 330px)" placeholder="详细地址" allowClear v-model="item.addr" :ref="`addr-${index}`" />
                          </a-input-group>
                        </div>
                        <a-space>
                          <a-button size="small" type="primary" icon="plus" title="添加" @click="onAddAddress(index + 1)"></a-button>
                          <a-button size="small" type="indigo" icon="minus" title="删除" @click="onRemoveAddress(index)" v-if="addressList.length > 1"></a-button>
                        </a-space>
                      </div>
                    </template>
                    <a-button size="small" type="primary" icon="plus" @click="onAddAddress(0)" v-else>添加实施地点</a-button>
                  </a-form-model-item>
                </a-col>
                <a-col span="24">
                  <a-form-model-item :colon="false" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                    <span slot="label">项目概述</span>
                    <a-textarea v-model="form.summary" ref="summary" placeholder="项目概述" :rows="6" style="width: 100%" />
                  </a-form-model-item>
                </a-col>
                <a-col span="24">
                  <a-form-model-item :colon="false" prop="capitalPoolId" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                    <span slot="label">
                      <i class="required-mark">*</i>
                      项目管理人员
                    </span>
                    <div class="text-left">
                      <a-button size="small" type="primary" icon="plus" @click="onAddMember">添加人员</a-button>
                    </div>
                    <a-table class="list-table" size="small" :bordered="false" :pagination="false" :data-source="memberList" :scroll="{ x: '100%' }" row-key="uid">
                      <!-- <a-table-column title="#" data-index="index" :width="55" align="center">
                        <template slot-scope="text, record, index">
                          {{ index + 1 }}
                        </template>
                      </a-table-column> -->
                      <a-table-column title="人员类型" data-index="memberDuty" :width="90" align="left">
                        <template slot="duty" slot-scope="text, record, index">
                          <a-select size="small" placeholder="选择人员类型" v-model="record.memberDuty" style="width: 100%" allowClear v-if="record.editing" :ref="`memberDuty${index}`">
                            <a-select-option v-for="item in duties" :key="item.value === void 0 ? item.label : item.value">
                              {{ item.label }}
                            </a-select-option>
                          </a-select>
                          <span v-else>{{ record.memberDuty }}</span>
                        </template>
                      </a-table-column>
                      <a-table-column title="姓名" data-index="memberName" :width="80" align="left">
                        <template slot="name" slot-scope="text, record, index">
                          <a-input v-model="record.memberName" size="small" :ref="`memberName${index}`" v-if="record.editing" />
                          <span v-else>{{ record.memberName }}</span>
                        </template>
                      </a-table-column>
                      <a-table-column title="职务" data-index="memberPost" :ellipsis="true" :width="80" align="left">
                        <template slot="name" slot-scope="text, record, index">
                          <a-input v-model="record.memberPost" size="small" :ref="`memberPost${index}`" v-if="record.editing" />
                          <span v-else>{{ record.memberPost }}</span>
                        </template>
                      </a-table-column>
                      <a-table-column title="联系电话" data-index="phone" :ellipsis="true" :width="105" align="left">
                        <template slot="name" slot-scope="text, record, index">
                          <a-input v-model="record.phone" size="small" :ref="`phone${index}`" v-if="record.editing" />
                          <span v-else>{{ record.phone }}</span>
                        </template>
                      </a-table-column>
                      <!-- <a-table-column title="工作经验" data-index="experience" :ellipsis="true" align="left">
                        <template slot="name" slot-scope="text, record, index">
                          <a-input v-model="record.experience" size="small" :ref="`experience${index}`" v-if="record.editing" />
                          <span v-else>{{ record.experience }}</span>
                        </template>
                      </a-table-column> -->
                      <a-table-column title="操作" data-index="action" :width="60" align="center">
                        <template slot-scope="text, record, index">
                          <a-space class="table-actions" :size="4">
                            <span class="table-action" title="编辑" @click="openMemberForm(record)"><a-icon type="form" /></span>
                            <span class="table-action text-red" title="删除" @click="onRemoveMember(index)"><a-icon type="close" /></span>
                          </a-space>
                        </template>
                      </a-table-column>
                    </a-table>
                  </a-form-model-item>
                </a-col>
                <a-col span="24">
                  <a-form-model-item :colon="false" prop="rsState" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
                    <span slot="label">项目材料</span>
                    <a-upload-dragger
                      class="avatar-uploader"
                      :action="`${baseURL}/file/upload`"
                      :data="{
                        params: JSON.stringify({ fileMark, projectId, fileBelongId: projectId, fileType: 2501, fileSign: 'P01' }),
                      }"
                      :show-upload-list="{
                        showPreviewIcon: true,
                        showRemoveIcon: true,
                        showDownloadIcon: true,
                      }"
                      :file-list="fileList"
                      :before-upload="beforeUploadFile"
                      @preview="handlePreviewFile"
                      @change="info => handleUploadChange(info, 'fileList')"
                      @download="({ fileId, name }) => downloadFile({ fileId, belongId: projectId, fileSign: 'P01', fileName: name })"
                      accept=".doc, .docx, .pdf"
                      ref="fileList"
                    >
                      <div class="v-pa-xs">
                        <a-icon type="upload" />
                        <p class="font-xs">点击选择或拖拽文件至上传区域，可上传多份</p>
                      </div>
                    </a-upload-dragger>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-form-model>
          </div>
        </div>
        <div class="text-center v-mt-lg">
          <a-space>
            <a-button icon="check" type="indigo" key="draft" @click="handleConfirm(false)" :loading="saving">保存初稿</a-button>
            <a-button icon="arrow-right" type="primary" key="submit" @click="handleConfirm(true)" :loading="saving">提交，进入项目执行</a-button>
            <a-button icon="left" type="default" key="backward" @click="$router.go(-1)">返回</a-button>
          </a-space>
        </div>
      </div>
    </div>
    <!-- 成员弹窗 -->
    <a-modal :visible="memberModal" :width="500" @cancel="cancelMemberModal" @ok="onSaveMember" centered :title="memberModalTitle">
      <a-form-model autocomplete="off" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
        <a-form-item :colon="false">
          <span slot="label">
            <i class="required-mark">*</i>
            人员类型
          </span>
          <a-select placeholder="选择人员类型" v-model="memberForm.memberDuty" style="width: 100%" ref="memberDuty">
            <a-select-option v-for="item in duties" :key="item.value === void 0 ? item.label : item.value">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :colon="false">
          <span slot="label">
            <i class="required-mark">*</i>
            姓名
          </span>
          <a-input v-model="memberForm.memberName" style="width: 100%" placeholder="联系人姓名" ref="memberName" />
        </a-form-item>
        <a-form-item :colon="false">
          <span slot="label">职务</span>
          <a-input v-model="memberForm.memberPost" style="width: 100%" placeholder="职务" ref="memberPost" />
        </a-form-item>
        <a-form-item :colon="false">
          <span slot="label">电话</span>
          <a-input v-model="memberForm.phone" style="width: 100%" placeholder="电话/手机号码" ref="phone" />
        </a-form-item>
        <a-form-item :colon="false">
          <span slot="label">工作经验</span>
          <a-textarea v-model="memberForm.experience" placeholder="工作经验" ref="experience" :rows="4" />
        </a-form-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { viewPrj, savePrj } from '@/api/project/other'
import alldistricts from '@/utils/districts'
const form = {
  name: '',
  code: '',
  target: '',
  type: undefined,
  startDate: undefined,
  endDate: undefined,
  ownManageRate: undefined,
  dates: [],
  summary: '',
}
const memberForm = {
  id: undefined,
  memberName: '',
  memberDuty: undefined,
  phone: '',
  memberPost: '',
  experience: '',
  memberState: 1,
}
export default {
  name: 'ProjectDraft',
  data() {
    return {
      projectId: this.$route.query.id,
      project: {},
      form: { ...form },
      memberList: [],
      addressList: [],
      fileMark: this.$utils.uuid(),
      districts: alldistricts,
      saving: false,
      applied: false,
      fileList: [],
      memberModal: false,
      memberModalTitle: '',
      memberForm: { ...memberForm },
    }
  },
  computed: {
    duties: vm => vm.$store.state.app.memberDuties,
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
        this.load()
      } else {
        this.onAddAddress(0)
      }
    },
    load() {
      this.loading = true
      viewPrj(this.projectId, true).then(({ data }) => {
        if (data.success) {
          let {
            name,
            startDate,
            endDate,
            target,
            summary,
            code,
            ownManageRate,
            otherInfo: { type },
            members = [],
            addresses = [],
            files = [],
          } = data.result
          this.project = data.result
          this.form = {
            name,
            startDate,
            endDate,
            type,
            code,
            target,
            summary,
            ownManageRate,
            dates: startDate && endDate ? [startDate.substring(0, 10), endDate.substring(0, 10)] : [],
          }
          this.fileList = files.map(file => ({
            ...file,
            uid: file.fileId,
            name: file.fileOriginName,
            status: 'done',
            fileSign: 'P01',
          }))
          this.memberList = members
          if (addresses.length > 0) {
            this.addressList = addresses.map(({ id, province, city, district, addr }) => {
              let districts = []
              if (province) {
                districts.push(province)
              }
              if (city) {
                districts.push(city)
              }
              if (district) {
                districts.push(district)
              }
              return {
                id,
                districts,
                addr,
              }
            })
          } else {
            this.onAddAddress()
          }
        }
      })
    },
    handleReset() {
      this.memberList = []
      this.form = { ...form }
    },
    handleUploadChange(info, ref) {
      if (ref && this.$refs[ref]) {
        this[ref] = this.handleUploadFile(info, -1)
        this.$refs[ref].$el.classList.remove('uploader-empty')
      }
    },
    onAddMember() {
      this.openMemberForm()
    },
    onAddAddress(index = 0) {
      this.addressList.splice(index, 0, {
        seq: Math.random(),
        districts: [],
        addr: '',
      })
    },
    onSaveMember() {
      let { uid, memberName, memberDuty, memberPost, experience, phone } = this.memberForm
      memberName = memberName.trim()
      this.$message.destroy()
      if (!memberDuty) {
        this.$message.warning('请选择人员类型')
        this.$refs.memberDuty.focus()
        return
      }
      if (memberName === '') {
        this.$message.warning('请输入人员姓名')
        this.$refs.memberName.focus()
        return
      }
      let formData = {
        uid,
        memberName,
        memberDuty,
        memberPost: memberPost.trim(),
        experience: experience.trim(),
        phone: phone.trim(),
      }
      let idx = this.memberList.findIndex(d => d.uid === uid)
      this.memberList.splice(idx > -1 ? idx : this.memberList.length, 1, formData)
      this.memberModal = false
    },
    openMemberForm(data) {
      if (data) {
        this.memberForm = { ...memberForm, ...data }
        this.memberModalTitle = '编辑人员'
      } else {
        this.memberModalTitle = '添加人员'
        this.memberForm = { ...memberForm, uid: this.$utils.uuid() }
      }
      this.memberModal = true
    },
    cancelMemberModal() {
      this.memberModal = false
    },
    onRemoveAddress(index) {
      this.addressList.splice(index, 1)
    },
    onRemoveMember(index) {
      this.memberList.splice(index, 1)
    },
    handleConfirm(nextStep) {
      let { type, name, ownManageRate, dates } = this.form
      this.$message.destroy()
      if (name.trim() === '') {
        this.$message.warning('请输入项目名称')
        this.$refs.name.focus()
        return
      }
      if (!type) {
        this.$message.warning('请选择项目类型')
        this.$refs.type.focus()
        return
      }
      const { isNum } = this.$utils
      if (!isNum(ownManageRate)) {
        this.$refs.ownManageRate.focus()
        this.$message.warning('请输入美丽心灵管理费率')
        return
      }
      if (dates.length == 0) {
        this.$message.warning('请选择实施周期')
        this.$refs.datePicker.focus()
        return
      }
      let addresses = this.addressList.filter(item => item.districts[0])
      if (addresses.length === 0) {
        this.$message.warning('请选择项目实施地点')
        if (this.$refs['districts-0'] && this.$refs['districts-0'][0]) {
          this.$refs['districts-0'][0].focus()
        }
        return
      }
      let members = this.memberList
      if (members.length === 0) {
        this.$message.warning('请添加项目管理人员')
        return
      }
      // let { fileList } = this
      // if (fileList.length === 0) {
      //   this.$message.warning('请上传培训班学员名单')
      //   this.$refs.fileList.$el.classList.add('uploader-empty')
      //   return
      // }
      this.$confirm({
        title: nextStep ? '确认提交？' : '确认保存初稿？',
        centered: true,
        onOk: () => {
          this.handleSubmit(nextStep)
        },
      })
    },
    handleSubmit(nextStep) {
      let { name, type, dates, target, summary, ownManageRate } = this.form
      let { projectId, fileList, fileMark, addressList } = this
      let addresses = addressList.filter(item => item.districts[0])
      let fileIds = fileList.map(file => file.fileId)
      let params = {
        id: projectId,
        name,
        // code,
        startDate: dates[0] ? `${dates[0]} 00:00` : undefined,
        endDate: dates[1] ? `${dates[1]} 00:00` : undefined,
        target,
        summary,
        fileIds,
        fileMark,
        ownManageRate,
        members: this.memberList,
        addresses: addresses.map(({ id, districts, addr }) => ({ id, province: districts[0], city: districts[1], district: districts[2], addr })),
        otherInfo: {
          type,
        },
        nextStep,
      }
      this.saving = true
      savePrj(params)
        .then(({ data }) => {
          if (data.success) {
            this.$message.success('操作成功')
            this.$router.push('list')
          } else {
            this.$message.warning(data.msg)
          }
          this.saving = false
        })
        .catch(err => {
          if (err) {
            this.$message.warning(err)
          }
          this.saving = false
        })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  },
  created() {
    this.init()
  },
}
</script>
